var _excluded = ["viewBox"];
function cov_2njl9lvujq() {
  var path = "/app/src/components/logo/components/logo-en-gray-on-transparent/logo-en-gray-on-transparent.tsx";
  var hash = "7e0fc27c3efca65a7a5e7c4d1c322298194675d2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-gray-on-transparent/logo-en-gray-on-transparent.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 39
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 49,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 39
          },
          end: {
            line: 5,
            column: 40
          }
        },
        loc: {
          start: {
            line: 8,
            column: 17
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 23
          }
        }],
        line: 6
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7e0fc27c3efca65a7a5e7c4d1c322298194675d2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2njl9lvujq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2njl9lvujq();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
cov_2njl9lvujq().s[0]++;
export var LogoEnGrayOnTransparent = function LogoEnGrayOnTransparent(_ref) {
  var _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? (cov_2njl9lvujq().b[0][0]++, '0 0 75 32') : _ref$viewBox,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2njl9lvujq().f[0]++;
  cov_2njl9lvujq().s[1]++;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: viewBox
  }, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8589 9.63684L65.1206 27.7288L65.1093 27.7699H68.7999L73.5559 9.63684H69.8589Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.22 19.9336C10.6666 20.2061 10.0575 20.3467 9.44065 20.3444C8.11155 20.3444 7.35735 20.1322 7.27534 19.0579V18.9856C7.27534 18.943 7.27051 18.9052 7.27051 18.8553V15.7267L7.27534 15.3585V13.153H7.27051V12.2146L7.27534 11.8432V9.71404L3.97872 10.149C6.20836 9.71725 7.48761 7.95316 7.48761 6.19469V5.11163H3.78333V10.1772L3.57428 10.2359V19.6168C3.6965 22.2524 5.43325 23.8187 8.28282 23.8187C9.2903 23.8187 10.3991 23.5896 11.2482 23.2044L11.2675 23.1964V19.9054L11.22 19.9336Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8046 8.95502L1.409 10.5575V13.1932L11.8046 11.5907V8.95502Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8046 12.8113L1.409 14.4138V16.9321L11.8046 15.3288V12.8113Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4714 14.0237C23.3243 11.0954 21.4942 9.36023 18.5128 9.36023C16.7986 9.36023 15.3858 10.022 14.4266 11.2755C13.4674 12.529 12.9656 14.3614 12.9656 16.5887C12.9656 18.8159 13.4706 20.654 14.4266 21.9027C15.3826 23.1514 16.7986 23.8179 18.5128 23.8179C21.4942 23.8179 23.3243 22.0739 23.4714 19.1303V23.5421H27.17V9.66899L23.4714 10.2399V14.0237ZM23.6644 16.5919C23.6644 19.1858 22.3023 20.8614 20.1949 20.8614C18.0239 20.8614 16.7254 19.2654 16.7254 16.5919C16.723 13.9031 18.0199 12.295 20.1925 12.295C21.249 12.295 22.1318 12.7067 22.7453 13.485C23.3444 14.2457 23.662 15.3191 23.662 16.5895L23.6644 16.5919Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9773 9.36101C34.9943 9.36101 33.1635 11.097 33.0187 14.0285V5.62939L29.3145 6.20108V23.5429H33.0187V19.1295C33.1635 22.0771 34.9943 23.8227 37.9773 23.8227C41.4677 23.8227 43.5518 21.1203 43.5518 16.5935C43.5518 12.0666 41.4677 9.36101 37.9773 9.36101ZM36.2952 20.859C34.187 20.859 32.8258 19.1833 32.8258 16.5894C32.8258 15.319 33.1426 14.2456 33.7424 13.4834C34.3559 12.7051 35.2387 12.2934 36.2952 12.2934C38.4662 12.2934 39.7647 13.9015 39.7647 16.5894C39.7647 19.2629 38.4678 20.859 36.2952 20.859Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6387 9.36101C50.6557 9.36101 48.8256 11.097 48.6801 14.0285V5.62939L44.9758 6.20108V23.5429H48.6801V19.1295C48.8256 22.0771 50.6557 23.8227 53.6387 23.8227C57.1291 23.8227 59.2132 21.1203 59.2132 16.5935C59.2132 12.0666 57.1291 9.36101 53.6387 9.36101ZM51.9566 20.859C49.8492 20.859 48.4871 19.1833 48.4871 16.5894C48.4871 15.319 48.8039 14.2456 49.4038 13.4834C50.0172 12.7051 50.9001 12.2934 51.9566 12.2934C54.1276 12.2934 55.4261 13.9015 55.4261 16.5894C55.4261 19.2629 54.1292 20.859 51.9566 20.859Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.222 9.63684H63.1772L66.3902 23.5172H62.8443L59.222 9.63684Z",
    fill: "#292929"
  }));
};